export default __webpack_public_path__ + "images/f57dcaa543160ea902f031c7028c3730-spirits.webp";